export function isUnsupportedScreenSize() {
  return window.innerWidth < 960 || window.innerHeight < 600;
}
